import { createGetPropGetter } from '@/store/utils';
// eslint-disable-next-line import/no-cycle
import project from '@/store/project';
// eslint-disable-next-line import/no-cycle
import user from '@/store/user';

export default {
  organizations: createGetPropGetter('organizations', []),
  organizationsTags(state) {
    const tagsPerOrganization = {};
    const {configurationOrganizationTags} = project.state;
    const {organizations} = state;
    if (state.organizations) {
      for (let i = 0; i < organizations.length; i += 1) {
        const currentOrganization = organizations[i];
        const configurationTagsForCurrentOrganization = configurationOrganizationTags.filter(item => item.configData.toLowerCase() === currentOrganization.name.toString().toLowerCase());
        const tagsForCurrentOrganization = configurationTagsForCurrentOrganization.map(item => ({...item.tags}));
        let mergedTags = {};
        tagsForCurrentOrganization.forEach(configuration => {
          mergedTags = {...mergedTags, ...configuration};
        });
        tagsPerOrganization[currentOrganization.name] = mergedTags || {};
      }
    }
    return tagsPerOrganization;
  },
  cloudAccountsPerOrganization(state) {
    const values = state.organizations?.map(org => [org.name, []]) || [];
    const cloudAccountsPerOrganizationMap = new Map(values);
    for (let i = 0; i < project.state.configurationCloudAccounts.length; i += 1) {
      const currentAccount = project.state.configurationCloudAccounts[i];
      const currentOrg = currentAccount.organization;
      const currentOrgName = currentOrg.name;
      if (cloudAccountsPerOrganizationMap.has(currentOrgName)) {
        const updatedValue = cloudAccountsPerOrganizationMap.get(currentOrgName);
        updatedValue.push(currentAccount.configData);
        cloudAccountsPerOrganizationMap.set(currentOrgName, updatedValue);
      }
    }
    const defaultOrganizationData = user.state.companyData;
    const defaultOrganizationName = defaultOrganizationData.name;
    if (!cloudAccountsPerOrganizationMap.has(defaultOrganizationName)) {
      cloudAccountsPerOrganizationMap.set(defaultOrganizationName, []);
    }
    return cloudAccountsPerOrganizationMap;
  },
  domainsPerOrganization(state) {
    const values = state.organizations?.map(org => [org.name, []]) || [];
    const domainsPerOrganizationMap = new Map(values);
    for (let i = 0; i < project.state.configurationDomains.length; i += 1) {
      const currentDomain = project.state.configurationDomains[i];
      const currentOrg = currentDomain.organization;
      const currentOrgName = currentOrg.name;
      if (domainsPerOrganizationMap.has(currentOrgName)) {
        const updatedValue = domainsPerOrganizationMap.get(currentOrgName);
        updatedValue.push(currentDomain.configData);
        domainsPerOrganizationMap.set(currentOrgName, updatedValue);
      }
    }
    const defaultOrganizationData = user.state.companyData;
    const defaultOrganizationName = defaultOrganizationData.name;
    const defaultOrganizationDomain = defaultOrganizationData.domain;
    if (!domainsPerOrganizationMap.has(defaultOrganizationName)) {
      domainsPerOrganizationMap.set(defaultOrganizationName, [defaultOrganizationDomain]);
    }
    return domainsPerOrganizationMap;
  },
};
